<mat-card appearance="outlined" id="cdn-card">
  <mat-card-header>
    <mat-card-title>
      {{ 'CDN_CARD.TITLE' | translate }}
      <a href="https://help.websitepro.hosting/?p=348" target="_blank">
        <mat-icon class="icon">open_in_new</mat-icon>
      </a>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="card-regular">
    <mat-card-subtitle>
      {{ 'CDN_CARD.SUBTITLE' | translate }}
    </mat-card-subtitle>
  </mat-card-content>
  <mat-card-actions>
    <form id="cdn-form">
      <mat-label id="cdn-label">
        {{ 'CDN_CARD.TOGGLE_LABEL' | translate }}
      </mat-label>
      <mat-slide-toggle
        id="cdn-toggle"
        name="cdn-setting"
        aria-label="(toggleLabel$ | async)"
        [disabled]="disableButton$ | async"
        [checked]="cdnEnabled$ | async"
        (change)="toggleVal($event.checked)"
      >
        {{ toggleStatusKey$ | async | translate }}
      </mat-slide-toggle>
    </form>
  </mat-card-actions>
</mat-card>
